import { render } from "./NavMainItem.vue?vue&type=template&id=f4d7abf0&scoped=true&ts=true"
import script from "./NavMainItem.vue?vue&type=script&lang=ts"
export * from "./NavMainItem.vue?vue&type=script&lang=ts"

import "./NavMainItem.vue?vue&type=style&index=0&id=f4d7abf0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d7abf0"]])

export default __exports__